import Vue from 'vue'
import api from '@gnb/api'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { mapGetters,mapActions } from 'vuex'
import * as types from '@account/store/types'
import * as accountTypes from '@gnb/store/types';

@Component({})
export default class ChoosePhoto extends Vue {

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  files: any | null = null
  fileSrc: any | null = null
  fileName: string = '첨부된 파일이 없습니다.'
  loadImageSrc: String | null = null
  formData: FormData = new FormData()
  @Prop({ type: Object }) user!: account.User;
  

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //
  getImageSrc(src: any) {
    if(src) {
      if(src.toLowerCase().startsWith("http") || src.toLowerCase().startsWith("https")) {
        return src;
      }            
    }
    return null;
  }

  fnSaveFileInfo(e: any) {
    this.files = e.target.files[0];
    this.fileSrc = URL.createObjectURL(e.target.files[0])
    // src = this.fileSrc.substr(5);
    this.fileName = e.target.files[0].name

    //this.formData = new FormData();
    this.formData.append("comCode", this.user.comCode);
    this.formData.append("personCode", this.user.personCode);
    this.formData.append("files", this.files);
    this.formData.append("email", this.user.email);
  }

  personImageSave(formData: FormData) {
    return api.common.insertPersonPhotoUpload(formData)
  }

  deleteImage() {
    this.formData = new FormData();
    this.formData.append("comCode", this.user.comCode);
    this.formData.append("personCode", this.user.personCode);
    this.formData.append("email", this.user.email);
    this.files = null;
    this.loadImageSrc = null;
    this.fileSrc = null;
    this.fileName = '첨부된 파일이 없습니다.';
  }

  loadImage() {
    if(this.user.photoPath != null) {
      this.loadImageSrc = this.user.photoPath
    }
  }

  save() {
    this.personImageSave(this.formData).then(async (res: any) => {
      if(res == -1) {
        await(window as any).alertAsync('저장_실패하였습니다')
      } else {
        await(window as any).alertAsync('저장하였습니다')
      }
    })
  }
  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E S Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  created() {
    this.loadImage()

    if(this.loadImageSrc != null){
      this.fileName = this.user.personCode + '.png';
    }
  }
}